module.exports = __webpack_public_path__ + "img/hot.dc23fa3.svg";